import Vue from 'vue'
import http from '@/server'
Vue.prototype.$http = http
const vm = new Vue()

const state = {
  clientOfZRTC: null,
  bigRoomInfo: null,
  socketMsg: {},
  listenedOnSignalMessage: false
}

const mutations = {
  setClientOfZRTC(state, client) {
    state.clientOfZRTC = client
  },
  setBigRoomInfo(state, info) {
    state.bigRoomInfo = info
    console.log('rommmmmm', info)
  },
  setSocketMsg(state, message) {
    state.socketMsg = message
  },
  setListenedOnSignalMessage(state, value) {
    state.listenedOnSignalMessage = value
  }
}

const actions = {
  // 获取roominfo
  async getBigRoomSocketInfo({ commit }, params) {
    return new Promise(async (resolve) => {
      const obj = {}
      if (params && params.schoolCode) {
        Object.assign(obj, { schoolCode: params.schoolCode })
      }
      const info = await vm.$http.getBigRoomSocketInfo(obj)
      console.log('roomid socket', info)
      if (info.code == 200) {
        commit('setBigRoomInfo', info.rt)
        resolve(info.rt)
      }
    })
  },
  // 获取sockt消息：
  getSocketMessage({ state, commit }) {
    console.log('getSocketMessage--------')
    if (state.listenedOnSignalMessage) return
    state.clientOfZRTC.onSignalMessage((data) => {
      commit('setListenedOnSignalMessage', true)
      commit('setSocketMsg', data.response)
    })
  },
  ZRTCInit({ state, commit, dispatch }, params) {
    return new Promise(async (resolve) => {
      //   let client = null
      state.clientOfZRTC && state.clientOfZRTC.leaveRoom()
      if (params && params.schoolCode) {
        await dispatch('getBigRoomSocketInfo', { schoolCode: params.schoolCode })
      } else {
        await dispatch('getBigRoomSocketInfo')
      }
      const { socketId, domain, port, token, socketRoomId } = state.bigRoomInfo
      // 每次切换学校后都需要重新初始化ZRTC
      //   client = ZRTC.init(socketRoomId)
      state.clientOfZRTC = ZRTC.init(socketRoomId)
      console.log('111🐶:>>>>>>>', new Date(), 'src/store/modules/bigScreenZrtc.js')

      try {
        await state.clientOfZRTC.joinBigRoom({
          socketId: socketId || '',
          domain: domain || '',
          port: port || 0,
          token: token || '',
          socketRoomId: socketRoomId || ''
        })
        console.log('333🐶:>>>>>>>', new Date(), 'src/store/modules/bigScreenZrtc.js')
        // client = state.clientOfZRTC
        console.log('client', state.clientOfZRTC)
      } catch (err) {
        console.log(err, 'joinRoom_err')
      }

      state.clientOfZRTC.setClientRole('audience', 'gomsg')
      commit('setClientOfZRTC', state.clientOfZRTC)
      resolve(state.clientOfZRTC)

      state.clientOfZRTC.onSignalMessage((data) => {
        commit('setListenedOnSignalMessage', true)
        commit('setSocketMsg', data.response)
      })
    })
  }
}

const getters = {
  getClientOfZRTC(state) {
    return state.clientOfZRTC
  },
  getSocketMsg(state) {
    return state.socketMsg
  },
  getListenedOnSignalMessage(state) {
    return state.listenedOnSignalMessage
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
